'use strict';

var App = require('app');
var Utils = require('models/utils');

var UserPermissions = Backbone.Model.extend({
    defaults: {
        modelType: 'user_permissions',
    },

    url: function () {
        return '/api/v1/devices/' + this.id + '/permissions?me';
    },

    sorted: function () {
        var permissionIDs = _.filter(_.keys(this.attributes), function (key) {
            return parseInt(key) !== NaN;
        });
        return permissionIDs.sort();
    },
});

var DeviceCapabilities = Backbone.Model.extend({
    url: function () {
        return '/api/v1/capabilities';
    },
});

var UserAdminEntry = Backbone.Model.extend({
    defaults: {
        modelType: 'user_admin_entry',
    },

    initialize: function (options) {
        Utils.SelectableModel.applyTo(this, options.is_owner === false);
    },

    urlRoot: function () {
        var deviceID = this.get('device') || this.collection.deviceID;
        return '/api/v1/devices/' + deviceID + '/permissions';
    },
});

var UserAdminEntryCollection = Backbone.Collection.extend({
    model: UserAdminEntry,
    comparator: 'name',

    initialize: function (options) {
        this.deviceID = options.deviceID || '';
        Utils.SelectableCollection.applyTo(this, options);
    },

    url: function () {
        return '/api/v1/devices/' + this.deviceID + '/permissions';
    },
});

var DeviceUserAdminEntry = Backbone.Model.extend({
    url: function () {
        var baseURL = '/api/v1/permissions';
        return this.get('deviceList') ? baseURL + '?devicelist=' + this.get('deviceList').join(',') : baseURL;
    },
});

var API = {
    // returns the capabilities for every device category
    getDeviceCapabilities: function () {
        var defer = $.Deferred();
        var capabilities = new DeviceCapabilities();
        capabilities.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });
        return defer.promise();
    },

    getUserPermissions: function (deviceID) {
        var defer = $.Deferred();

        if (deviceID) {
            var permissions = new UserPermissions({ id: deviceID });
            permissions.fetch({
                success: function (data) {
                    defer.resolve({ data: data });
                },
                error: function (data, err) {
                    defer.resolve({ status: status });
                },
            });
        } else {
            // permissions can not be determined
            defer.resolve(undefined);
        }

        return defer.promise();
    },

    getSharedDevicePermissions: function (deviceList) {
        var defer = $.Deferred();
        var permissions = new DeviceUserAdminEntry({ deviceList: deviceList });
        permissions.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getDevicePermissionsOfAuthorizedUsers: function (deviceID) {
        var defer = $.Deferred();
        var permissions = new UserAdminEntryCollection({ deviceID: deviceID });
        permissions.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('permissions:me', function (id) {
    return API.getUserPermissions(id);
});

App.reqres.setHandler('device:permissions:shared', function (deviceIDs) {
    return API.getSharedDevicePermissions(deviceIDs);
});

App.reqres.setHandler('device:permissions:authorized_users', function (id) {
    return API.getDevicePermissionsOfAuthorizedUsers(id);
});

App.reqres.setHandler('device:capabilities', function () {
    return API.getDeviceCapabilities();
});

module.exports = {
    User: UserPermissions,
    Model: UserAdminEntry,
    Collection: UserAdminEntryCollection,
    DevicesModel: DeviceUserAdminEntry,
};
